import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/** Cream pill — matches Artist Salon / Artists directory nav. */
export const premiumBackPillClass =
  'inline-flex shrink-0 items-center gap-1.5 rounded-full border border-[#E8C97A] bg-[#FFF9EF] px-2.5 py-1.5 text-[11px] font-semibold text-[#5C4428] shadow-[0_4px_14px_rgba(120,72,20,0.06)] transition-all duration-300 ease-out hover:-translate-y-0.5 hover:border-[#F5CB5C] hover:shadow-[0_8px_20px_rgba(120,72,20,0.1)] sm:px-3 sm:py-2 sm:text-xs';

/** Gold gradient icon control — public profile & compact headers. */
export const premiumBackIconClass =
  'inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-[rgba(245,203,92,0.5)] bg-gradient-to-br from-[#FFE9B8] via-[#F5D99B] to-[#F5CB5C] text-[#5A4632] shadow-[0_8px_22px_rgba(120,72,20,0.14)] ring-1 ring-white/60 transition-all duration-300 ease-out hover:-translate-y-0.5 hover:shadow-[0_12px_28px_rgba(245,158,11,0.22)]';

function PremiumBackArrow({ inBadge = false }) {
  if (inBadge) {
    return (
      <span
        className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#F59E0B] to-[#F97316] text-white shadow-[0_2px_8px_rgba(234,88,12,0.35)]"
        aria-hidden
      >
        <ArrowLeft className="h-3.5 w-3.5" strokeWidth={2.5} />
      </span>
    );
  }
  return (
    <span
      className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-[#F59E0B] to-[#F97316] text-white shadow-[0_3px_10px_rgba(234,88,12,0.32)]"
      aria-hidden
    >
      <ArrowLeft className="h-4 w-4" strokeWidth={2.5} />
    </span>
  );
}

/**
 * Premium back control — gradient arrow badge on pill or gold icon button.
 * @param {'pill'|'icon'} variant
 */
export default function PremiumBackButton({
  to = -1,
  onClick,
  label = 'Back',
  variant = 'pill',
  className = '',
  title,
  showLabel = true,
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    navigate(to);
  };

  if (variant === 'icon') {
    return (
      <button
        type="button"
        onClick={handleClick}
        className={`${premiumBackIconClass} ${className}`.trim()}
        title={title || label}
        aria-label={title || label}
      >
        <PremiumBackArrow />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`${premiumBackPillClass} ${className}`.trim()}
      title={title || label}
      aria-label={title || label}
    >
      <PremiumBackArrow inBadge />
      {showLabel ? <span>{label}</span> : null}
    </button>
  );
}
